import React from "react";

import FormField from "../form-field/FormField";

interface CreatedBy {
  createdBy?: string;
}
export default function DisplayCreatedBy(props: CreatedBy) {
  return (
    <FormField
      id="created-by"
      labelKey="general.created-by"
      readOnly
      fieldValue={props.createdBy || "-"}
    />
  );
}
